<template>
    <div>

        <transition>
            <!-- Next -->
            <div v-if="state === 'next'">
                <div class="uk-card uk-card-default uk-card-small">

                    <header class="uk-card-header">

                        <div class="uk-grid-small" uk-grid>

                            <h2 class="uk-width-expand uk-flex uk-flex-middle">
                                            <span class="uk-badge uk-badge-large uk-margin-small-right"
                                                  style="background: gray;">3</span>
                                <span class="uk-text-muted">Payment</span>
                            </h2>

                        </div>

                    </header>

                </div>
            </div>

            <!-- Editable -->
            <div v-if="state === 'editable'">
                <div class="uk-card uk-card-default uk-card-small">

                    <header class="uk-card-header">

                        <div class="uk-grid-small" uk-grid>

                            <h2 class="uk-width-expand uk-flex uk-flex-middle">
                                <span class="uk-badge uk-badge-large uk-margin-small-right">3</span>
                                <span>Payment</span>
                            </h2>

                        </div>

                    </header>

                    <div class="uk-card-body">

                        <h3 class="uk-text-center">Payment Method</h3>

                        <div class="uk-grid-small uk-child-width-auto uk-flex uk-flex-center" uk-grid>

                            <div class="uk-width-1-2 uk-width-1-3@s tm-choose">
                                <input v-model="paymentType.online" :value="false" class="uk-radio" id="type-5" type="radio" name="radio3">
                                <label for="type-5">
                                    <div class="tm-choose-title">On Receipt</div>
                                </label>
                            </div>

                            <div class="uk-width-1-2 uk-width-1-3@s tm-choose">
                                <input v-model="paymentType.online" :value="true" class="uk-radio" id="type-6" type="radio" name="radio3">
                                <label for="type-6">
                                    <div class="tm-choose-title">Online</div>
                                </label>
                            </div>

                        </div>
                        <div class="uk-text-center uk-margin-medium">
                            <button @click.prevent="$emit('cart::nextStep')" class="uk-button uk-button-primary">
                                <span>Next Step</span>
                                <span class="uk-margin-small-left uk-icon" uk-icon="icon: arrow-right"></span>
                            </button>
                        </div>

<!--                        <h3 class="uk-text-center">Card Info</h3>

                        <div class="uk-grid-small" uk-grid>

                            <div class="uk-width-1-1">
                                <label class="uk-form-label">Name <span
                                        class="uk-text-danger">*</span></label>
                                <input v-model="Card.holder" class="uk-input" type="text">
                            </div>

                            <div class="uk-width-1-1">
                                <label class="uk-form-label">Card Number <span
                                        class="uk-text-danger">*</span></label>
                                <input v-model="Card.number" class="uk-input" type="text">
                            </div>

                            <div class="uk-width-1-3@s uk-width-1-2">
                                <label class="uk-form-label">Month <span
                                        class="uk-text-danger">*</span></label>
                                <input v-model="Card.expMonth" class="uk-input" type="text">
                            </div>

                            <div class="uk-width-1-3@s uk-width-1-2">
                                <label class="uk-form-label">Year <span
                                        class="uk-text-danger">*</span></label>
                                <input v-model="Card.expYear" class="uk-input" type="text">
                            </div>

                            <div class="uk-width-1-3@s uk-width-1-2">
                                <label class="uk-form-label">CVV <span
                                        class="uk-text-danger">*</span></label>
                                <input v-model="Card.cvv" class="uk-input" type="text">
                                <input name="token" v-model="cardToken" class="uk-input" type="text">
                            </div>
                            <button @click.prevent="generateToken()">click</button>
                            <button type="submit">send</button>
                        </div>-->

                    </div>

                </div>
            </div>

            <!-- Ready -->
            <div v-if="state === 'completed'">
                <div class="uk-card uk-card-default uk-card-small">

                    <header class="uk-card-header">

                        <div class="uk-grid-small" uk-grid>

                            <h2 class="uk-width-expand uk-flex uk-flex-middle">
                                            <span class="uk-badge uk-badge-large uk-margin-small-right cart-badge-success">
                                                <span class="uk-icon" uk-icon="icon: check"></span>
                                            </span>
                                <span class="uk-text-muted">Payment</span>
                            </h2>


                            <div class="uk-width-auto uk-flex uk-flex-middle">
                                <a @click.prevent="$emit('cart::editStep')" class="uk-link-muted">
                                    <span uk-icon="icon: pencil" class="uk-icon"></span>
                                    <span>Edit</span>
                                </a>
                            </div>
                        </div>

                    </header>

                    <div class="uk-card-body">

                        <div class="uk-grid-small uk-text-small uk-text-muted" uk-grid>

                            <div class="uk-width-1-3">
                                <dl class="uk-description-list">

                                    <dt>Payment Method</dt>
                                    <dd>Online</dd>

                                </dl>
                            </div>

<!--                            <div class="uk-width-expand">
                                <dl class="uk-description-list">

                                    <dt>Name</dt>
                                    <dd>Tulenev Egor</dd>

                                    <dt>Card Number</dt>
                                    <dd>23982348099283</dd>

                                    <dt>Month</dt>
                                    <dd>November</dd>

                                    <dt>Year</dt>
                                    <dd>2017</dd>

                                    <dt>CVV</dt>
                                    <dd>123</dd>

                                </dl>
                            </div>-->

                        </div>

                    </div>

                </div>
            </div>
        </transition>

    </div>
</template>
<script>
    export default {
        props: {
            state: {
                'type': String,
                'required': true,
                'default': 'next'
            },
        },
        data(){
            return {
                paymentType: {
                    online: true
                }
            }
        },
        mounted(){
            this.$emit('update:data', {paymentType: this.paymentType});
        },
        methods: {

        }
    }
</script>

<!--
    // Called when token created successfully.
    var successCallback = function(data) {
        var myForm = document.getElementById('myCCForm');

        // Set the token as the value for the token input
        myForm.token.value = data.response.token.token;

        // IMPORTANT: Here we call `submit()` on the form element directly instead of using jQuery to prevent and infinite token request loop.
      //  myForm.submit();
    };

    // Called when token creation fails.
    var errorCallback = function(data) {
        if (data.errorCode === 200) {
            // This error code indicates that the ajax call failed. We recommend that you retry the token request.
        } else {
            alert(data.errorMsg);
        }
    };

    var tokenRequest = function() {
        // Setup token request arguments
        var args = {
            sellerId: "901348764",
            publishableKey: "DCAEAC6C-93A5-46AE-A487-6C1E2984E56F",
            ccNo: $("#ccNo").val(),
            cvv: $("#cvv").val(),
            expMonth: $("#expMonth").val(),
            expYear: $("#expYear").val()
        };

        // Make the token request
        TCO.requestToken(successCallback, errorCallback, args);
    };

    $(function() {
        // Pull in the public encryption key for our environment
        TCO.loadPubKey('sandbox');

        $("#myCCForm").submit(function(e) {
            // Call our token request function
            tokenRequest();

            // Prevent form from submitting
            return false;
        });
    });
-->



// WEBPACK FOOTER //
// CartPayment.vue?a57afd1e